// HOOK OF SELECT
import Select                        from 'react-select'
import React, { Fragment, useState } from 'react'
const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
};    
const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center"
};

export default function useSelect({ initialState, optionsState, isClearable, isDisabled, setInvalid, setMesssage, placeholder, bgSize }) {
    const formatGroupLabel = (data) => (
        <div style={groupStyles}>
          <strong>{data.label}</strong>
          <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    )

    const   [value, setValue] = useState(initialState ? initialState : ''),
            select = (
                <Fragment>
                    {
                        setInvalid ? (
                            <div style={{ borderColor: 'red', forcedColorAdjust: 'red', boxShadow: '0 0 0 .3rem rgba(255, 4, 69, .50)', borderRadius: '10px' }}>
                                <Select
                                    value            = {(optionsState ? optionsState : []).filter(element => element.value === value)}
                                    placeholder      = {placeholder ? placeholder : "Seleccionar Opción"}
                                    options          = {(optionsState ? optionsState : [])}
                                    isClearable      = {isClearable ? isClearable : false}
                                    isDisabled       = {isDisabled ? isDisabled : false}
                                    onChange         = {e => setValue(e ? e.value : '')}
                                    isOptionDisabled = {option => option.disabled}
                                    noOptionsMessage = {() => 'Sin opciones'}
                                    bsSize           = {bgSize ? bgSize : "sm"}
                                    getOptionLabel   = {({ label }) => label}
                                    getOptionValue   = {({ value }) => value}
                                    formatGroupLabel = {formatGroupLabel}
                                />
                            </div>
                        ) : (
                            <Select
                                value            = {(optionsState ? optionsState : []).filter(element => element.value === value)}
                                placeholder      = {placeholder ? placeholder : "Seleccionar Opción"}
                                options          = {(optionsState ? optionsState : [])}
                                isClearable      = {isClearable ? isClearable : false}
                                isDisabled       = {isDisabled ? isDisabled : false}
                                onChange         = {e => setValue(e ? e.value : '')}
                                isOptionDisabled = {option => option.disabled}
                                noOptionsMessage = {() => 'Sin opciones'}
                                bsSize           = {bgSize ? bgSize : "sm"}
                                getOptionLabel   = {({ label }) => label}
                                getOptionValue   = {({ value }) => value}
                                formatGroupLabel = {formatGroupLabel}
                            />
                        )
                    }

                    {
                    (setInvalid)? 
                        <small className="text-danger">{(setMesssage.length > 0 ? setMesssage : '')} </small> 
                    : 
                        <></>
                    }
                </Fragment>
            )

    return {
        get: value, 
        select, 
        set: setValue
    }
}